var chunkMapping = {
	"8594": [
		58594
	]
};
var idToExternalAndNameMapping = {
	"58594": [
		"default",
		"./HeaderHomeNotification",
		75277
	]
};
var idToRemoteMap = {
	"58594": [
		{
			"externalType": "script",
			"name": "notification",
			"externalModuleId": 75277
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}